export const typeVoucherOptions = [
	{
		text: 'Fixed Amount',
		value: 'fixed',
	},
	{
		text: 'Percentage',
		value: 'percentage',
	},
	{
		text: 'Shipping',
		value: 'shipping',
	},
]
